import React from 'react';

import CountryProfile from '../components/CountryProfile';

import {
  UNROCADatabase,
  COMTRADEDatabase,
  OECDDatabase
} from '../components/RelatedDatabases';

import { InfoIcon } from '../components/base-components/Info-icon';

import { getCountryName } from '../helpers/countryNames';

export default props => {
  const countryCode = props.params.id,
    countryName = getCountryName(countryCode);

  return (
    <div style={{ marginTop: '-25px' }}>
      {' '}
      {/* hack to make breadcrump align with gray outer area... */}
      <ol className="breadcrumb">
        <li>
          <a href="/">Country profiles</a>
        </li>
        <li className="active">{ countryName }&#39;s country profile</li>
      </ol>
      <div className="country-profile-body">
        <div className="row">
          <div className="col-md-8">
            <div className="mainrecord-wrapper">
              <CountryProfile countryCode={ countryCode } countryName={ countryName } />
            </div>
          </div>

          <div className="col-md-4">
            <div className="sourcebox-wrapper">
              <h3 className="sourcebox-wrapper-title">
                Related databases{' '}
                <InfoIcon>
                  {' '}
                  <p>...</p>
                </InfoIcon>
              </h3>
              <div className="sourcebox-disclaimer" />
              <UNROCADatabase countryName={ countryName } />
              <COMTRADEDatabase countryCode={ countryCode } />
              <OECDDatabase countryCode={ countryCode } />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/CountryProfile.js